export enum StorageKey {
    theme = 'THEME_PREFERENCE',
    httpCache = 'HTTP_CACHE',
    municipalities = 'MUNICIPALITIES',
    commonFilters = 'COMMON_FILTERS',
    servicesFilters = 'SERVICES_FILTERS',
    userFilters = 'USERS_FILTERS',
    backOfficeFilters = 'BACK_OFFICE_FILTERS',
    operatorsFilters = 'OPERATORS_FILTERS',
    globalSchedulerFilters = 'GLOBAL_SCHEDULER_FILTERS',
    assetsFilters = 'ASSETS_FILTERS',
    structuresFilters = 'STRUCTURES_FILTERS',
    vehiclesFilters = 'VEHICLES_FILTERS',
    userChatsFilters = 'USERS_CHATS_FILTERS',
    operationalUnitFilters = 'OPERATIONAL_UNIT_FILTERS',
    patientFilters = 'PATIENTS_FILTERS',
    patientCashMovementFilters = 'PATIENTS_CASH_MOVEMENT_FILTERS',
    cashMovementFilters = 'CASH_MOVEMENT_FILTERS',
    patientDetailMovementFilters = 'PATIENT_DETAIL_MOVEMENT_FILTERS',
    transferRequestFilters = 'TRANSFER_REQUEST_FILTERS',
    patientDischargedFilters = 'PATIENT_DISCHARGED_FILTERS',
    staffFilters = 'STAFF',
    handoverFilters = 'HANDOVER_FILTERS',
    patientModuleFilters = 'PATIENT_MODULE_FILTERS',
    patientMealReportFilters = 'PATIENT_MEAL_REPORTS_FILTERS',
    eventSubmissionFilters = 'EVENT_SUBMISSION_FILTERS',
    viewCalendarFilters = 'VIEW_CALENDAR_FILTERS',
    temperatureFilters = 'TEMPERATURE_FILTERS',
    dailyCleaningEventFilters = 'DAILY_CLEANING_EVENT_FILTERS',
    registerCleaningEventFilters = 'REGISTER_CLEANING_EVENT_FILTERS',
    notificationFilters = 'NOTIFICATION_FILTERS',
    documentFilters = 'DOCUMENTS_FILTERS',
    patientTransferRequestFilters = 'PATIENT_TRANSFER_REQUEST_FILTERS',
    medicationFilters = 'MEDICATION_FILTERS',
    medicationChronologyFilters = 'MEDICATION_CHRONOLOGY_FILTERS',
    operationalUnitStockChronologyFilters = 'OPERATIONAL_UNIT_STOCK_CHRONOLOGY_FILTERS',
    patientStockChronologyFilters = 'PATIENT_STOCK_CHRONOLOGY_FILTERS',
    medicationTherapyFilters = 'MEDICATION_THERAPY_FILTERS',
    therapyChronologyFilters = 'THERAPY_CHRONOLOGY_FILTERS',
    underStockFilters = 'UNDER_STOCK_FILTERS',
    medicationOrderFilters = 'MEDICATION_ORDER_FILTERS',
    medicationOrderHistoryFilters = 'MEDICATION_ORDER_HISTORY_FILTERS',
    labelPrintingFilters = 'LABEL_PRINTING_FILTERS',
    medicationStockFilters = 'MEDICATION_STOCK_FILTERS',
    medicationCartFilters = 'MEDICATION_CART_FILTERS',
    patientMedicationStockFilters = 'PATIENT_MEDICATION_STOCK_FILTERS',
    tenantUrl = 'TENANT_URL',
    patientBalanceFilters = 'PATIENT_BALANCE_FILTERS',
    diaryFilters = 'DIARY_FILTERS',
    generalAffairsStaffFilters = 'GENERAL_AFFAIRS_STAFF_FILTERS',
}
